var Scene7ParamMap;

(function (Scene7ParamMap) {
  Scene7ParamMap["width"] = "wid";
  Scene7ParamMap["height"] = "hei";
  Scene7ParamMap["quality"] = "qlt";
  Scene7ParamMap["format"] = "fmt";
})(Scene7ParamMap || (Scene7ParamMap = {}));

var SourceImageFormat;

(function (SourceImageFormat) {
  SourceImageFormat["pjpeg"] = "pjpeg";
  SourceImageFormat["jpeg"] = "jpeg";
})(SourceImageFormat || (SourceImageFormat = {}));

export { Scene7ParamMap, SourceImageFormat };
